import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { PaginationLimit } from 'src/app/core/constants/dropdown-contants';
import { CacheUserService } from './services/cache-user.service';

@Component({
  selector: 'app-user-dropdown-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit, OnChanges {
  @Input() control: FormControl = new FormControl('');
  @Input() label: string = 'user';
  @Input() placeholder: string = 'Select user';
  @Input() selecteduser: string = '';
  @Input() userType: string = '';
  @Input() isCaseOwner: boolean = false;
  @Input() showAlluser: boolean = false;
  @Input() showUser:boolean = false;
  @Input() multiple: boolean = false;
  @Output() search: EventEmitter<string> = new EventEmitter<string>();
  @Output() nextOffsetuser: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() userDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();

  userList: any[] = [];
  paginationLimit: number = PaginationLimit.user;
  totaluserCount: number = 0;
  userOffset: number = PaginationLimit.user;
  userPagination = {
    skip: 0,
    limit: PaginationLimit.user
  };
  userFilter: FormControl = new FormControl('');
  isLoading: boolean = false;
  searchValue: BehaviorSubject<string> = new BehaviorSubject('')

  constructor(
    private _cacheuserService: CacheUserService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selecteduser']?.currentValue) {
      if (this.userList.length === 0) {
        this.getuser();
      } else if (this.multiple) {
        // For multiple selection, check if all selected users exist
        const selectedIds = Array.isArray(this.selecteduser) ? this.selecteduser : [this.selecteduser];
        selectedIds.forEach(id => {
          if (!this.userList.some(u => u.id === id)) {
            this.checkuserExists(id);
          }
        });
      } else {
        // For single selection
        this.checkuserExists(changes['selecteduser'].currentValue);
      }
    }
  }

  async ngOnInit() {
    this.getuser();
  }

  async getuser() {
    await this.loadusers();
    if (this.selecteduser) {
      this.checkuserExists(this.selecteduser);
    }
  }

  private async loadusers(filter: string = ''): Promise<void> {
    if (filter) {
      this.userPagination = {
        skip: 0,
        limit: PaginationLimit.user
      }
      this.userList = [];
    }
    try {
      this.isLoading = true;  // Set loading to true before making the API call
      // Fetch universities using the cache service
      const userData: { data: any[], total: number } = await this._cacheuserService.fetchusers(this.userPagination, filter, this.userType);

      // Update userList and total count
      const userList = this.userType === 'caseowner' ? userData.data?.map((v: any) => ({ name: `${v?.userDetails?.firstName ?? ''} ${v?.userDetails?.lastName ?? ''}`, id: v?.id })) :
        userData.data.map((v: any) => ({ name: `${v?.userDetails?.firstName ?? ''} ${v?.userDetails?.lastName ?? ''}`, id: v?.id }));

      this.userList = [...this.userList, ...userList];
      if (this.showAlluser) {
        this.userList.unshift({
          id: '',
          name: `All ${this.userType}`
        },
        {
          id: '0',
          name: 'RM Not Assigned'
        })
      }
      if(this.showUser){
        this.userList.unshift({
          id: '',
          name: `All ${this.userType}`
        })
      }
      this.userList = [...new Set(this.userList)];

      this.totaluserCount = userData.total;

    } catch (error) {
      
      console.error('Error loading universities:', error);
    } finally {
      this.isLoading = false;  
    }
  }


  private checkuserExists(userId: string): void {
    // Add a check to prevent duplicate API calls
    if (userId && !this.userList.some((u) => u.id === userId)) {
      this._cacheuserService.getuserById(userId).subscribe({
        next: (user) => {
          if (user && user?.statusCode === 200 && user?.data) {
            // Check again before adding to prevent race conditions
            if (!this.userList.some(u => u.id === userId)) {
              this.userList.push({
                name: `${user?.data[0]?.userDetails?.firstName ?? ''} ${user?.data[0]?.userDetails?.lastName ?? ''}`,
                id: user?.data[0]?.id
              });
              this.userList = [...this.userList]; // Trigger change detection
            }
          } else {
            console.warn(`user with ID ${userId} not found.`);
          }
        },
        error: (err) => console.error('Error fetching user by ID:', err)
      });
    }
  }

  getNextuser(): void {
    if (this.searchValue?.value) return
    if (this.userPagination.skip < this.totaluserCount) {
      this.userPagination.skip += this.paginationLimit;
      this.isLoading = false;
      this.showAlluser = false;
      this.loadusers(this.userFilter.value);
    }
  }

  async filteruser(filter: string) {
    this.searchValue.next(filter);
    this.userList = [];
    await this.loadusers(filter);
    if (this.control.value) {
      this.checkuserExists(this.control.value);
    }
  }
  onSelectionChange(event: any) {
    this.selectionChange.emit(event)
  }
}
